<div class="attendance-verification-status">
  <lv-session-attendance-status [sessions]="[session]"></lv-session-attendance-status>
</div>

<div class="photos">
  @if (facePhotoUrl) {
    <lv-captioned-image
      [src]="facePhotoUrl"
      [allowRetake]="liveAgent"
      caption="Face Photo"
      (retake)="retakePhoto()"
    ></lv-captioned-image>
  }
  @if (idPhotoUrl) {
    <lv-captioned-image
      [src]="idPhotoUrl"
      [allowRetake]="liveAgent"
      caption="ID Photo"
      (retake)="retakeID()"
    ></lv-captioned-image>
  }
</div>

@if (retakeRequests.length) {
  <lv-list-retake-requests [retakeRequests]="retakeRequests"></lv-list-retake-requests>
} @else {
  <div class="no-retake-requests" translate>agent-verify-id.component.no-requests</div>
}
